import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { vuetify } from './plugins/vuetify'
import { installCasl } from './plugins/casl'
import { onUnauthenticated } from './api/http'
import { useAuthStore } from './stores/auth.store'

async function bootstrap() {
  const app = createApp(App)
  const pinia = createPinia()

  app.use(pinia)
  app.use(router)
  app.use(vuetify)
  installCasl(app)

  // Глобальный handler 401 после неудачного refresh → чистим store и кидаем на /login.
  // router.push доступен только после установки роутера.
  onUnauthenticated(() => {
    const auth = useAuthStore()
    auth.clearUser()
    if (router.currentRoute.value.path !== '/login') {
      router.push({ path: '/login', query: { redirect: router.currentRoute.value.fullPath } })
    }
  })

  // restoreSession инициирует navigation guard router.beforeEach,
  // но мы хотим избежать «вспышки» login при F5 на залогиненной сессии.
  // Дождёмся восстановления перед монтированием.
  const auth = useAuthStore()
  await auth.restoreSession()

  app.mount('#app')
}

bootstrap().catch((err) => {
  // eslint-disable-next-line no-console
  console.error('Admin bootstrap failed', err)
})
